import axios from 'axios'
export const baseUrl = 'https://customized.drcnet.com.cn' // 用户环境
const http = axios.create({
        baseURL: baseUrl,
        // baseURL: '/test',
        // withCredentials: true,
        // 请求 30s 超时s
        timeout: 300000
    })
    // 手动挂载2个方法
http.all = axios.all
http.spread = axios.spread
export function ajaxGetCode(url, params) {
    return http.get(url, params).then((res) => res);
}
export function ajaxPostCode(url, params) {
    return http.post(url, params).then((res) => res);
}
export function ajaxpostExport(url, data, fileName, type) {
    return http
        .post(url, data, {
            responseType: "blob",
        })
        .then((result) => {
            console.log("result", result);
            // const contentDisposition = result.headers["content-disposition"];
            const filename = decodeURI(`${fileName}.${type}`);
            const blob = new Blob([result.data]);
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.style.display = "none";
            link.href = url;
            link.setAttribute("download", filename);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        });
}
export function ajaxpostExportWithGet(url) {
    return http({
        method: "get",
        url: url,
        responseType: "blob"
    }).then((result) => {
        // 从响应头中获取Content-Disposition头部
        const contentDisposition = response.headers['content-disposition'];

        // 从Content-Disposition头部中提取文件名
        const matches = /filename="(.*)"/.exec(contentDisposition);
        const filename = matches && matches[1] ? decodeURI(matches[1]) : 'downloaded-file';

        const blob = new Blob([response.data]);
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.style.display = "none";
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    });
}

export default http